export const newQueryString = (params: Record<string, string>) => {
  const res = new URLSearchParams(params)
  return '?' + res.toString()
}
